import { render, staticRenderFns } from "./tabInternationalCardBaseMaster.vue?vue&type=template&id=0483af72&scoped=true&"
import script from "./tabInternationalCardBaseMaster.vue?vue&type=script&lang=js&"
export * from "./tabInternationalCardBaseMaster.vue?vue&type=script&lang=js&"
import style0 from "./tabInternationalCardBaseMaster.vue?vue&type=style&index=0&id=0483af72&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0483af72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0483af72')) {
      api.createRecord('0483af72', component.options)
    } else {
      api.reload('0483af72', component.options)
    }
    module.hot.accept("./tabInternationalCardBaseMaster.vue?vue&type=template&id=0483af72&scoped=true&", function () {
      api.rerender('0483af72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Integrated/components/booking/tabs/tabInternationalCardBaseMaster.vue"
export default component.exports